import { Api } from '../api';
import { messages } from '../endpoints';
import type { ApiResponse, FileResponse } from '../../models';
import type {
  AddAttachmentsRequest,
  AddAttachmentsResponse,
  AddMessageRequest,
  AddMessageResponse,
  DownloadAttachmentRequest,
  ReadThreadsRequest,
  ReadThreadsResponse,
  RemoveAttachmentsRequest,
  ThreadsMessagesResponse,
  ThreadsResponse,
} from './models';

export class MessagesApi extends Api {
  static getThreads = (signal?: AbortSignal) => this.get<ApiResponse<ThreadsResponse[]>>({ url: messages.getThreads(), signal });

  static getThreadsMessages = (groupId: string) => this.get<ApiResponse<ThreadsMessagesResponse[]>>({ url: messages.getThreadsMessages(groupId) });

  static readThread = (request: ReadThreadsRequest) =>
    this.put<ReadThreadsRequest, ApiResponse<ReadThreadsResponse>>({ url: messages.readThread(), data: request });

  static deleteThread = (groupId: string) => this.delete({ url: messages.deleteThread(groupId) });

  static addAttachments = ({ request, messageId }: AddAttachmentsRequest) =>
    this.post<FormData, ApiResponse<AddAttachmentsResponse>>({ url: messages.addAttachments(messageId), data: request });

  static addMessage = (request: AddMessageRequest) =>
    this.post<AddMessageRequest, ApiResponse<AddMessageResponse>>({ url: messages.addMessage(), data: request });

  static downloadAttachment = ({ fileId, messageId }: DownloadAttachmentRequest) =>
    this.get<FileResponse>({ url: messages.downloadAttachment(fileId, messageId) });

  static removeAttachment = ({ fileId, messageId }: RemoveAttachmentsRequest) => this.delete({ url: messages.removeAttachment(fileId, messageId) });
}
